Dude        = require './game/dude'
RifleMan    = require './game/rifleman'
Tile        = require './game/tile'
GridHelper  = require './game/utilties/grid'
LevelLoader = require './game/levels/levelLoader'

stage = new createjs.Stage "canvas"
stage.mouseEventsEnabled = true
stage.snapToPixelsEnabled = true

@gameObjects = []
@dude = undefined

levelLoader = new LevelLoader stage
currentLevel = 1
levelLoader.makeLevel currentLevel, (tiles) ->
  props = ["wid", "hei", "scrWidth", "scrHeight", "easystar"]
  (this[prop] = levelLoader[prop] for prop in props)

  gridHelper = new GridHelper wid, hei, scrWidth, scrHeight, easystar

  tiles = tiles.map (t) ->
    new Tile t.x, t.y, gridHelper, t.image
  @gameObjects = @gameObjects.concat tiles
  for tile in tiles
    stage.addChild tile.drawable

  @dude = new Dude 100, 100, gridHelper, scrWidth, scrHeight
  @gameObjects.push @dude
  stage.addChild @dude.drawable

  rifleMan = new RifleMan 100, 100, gridHelper
  @gameObjects.push rifleMan
  stage.addChild rifleMan.drawable

createjs.Ticker.setFPS 20

createjs.Ticker.on 'tick', =>
  if @dude?
    @gameObjects.map (obj) ->
      obj.update @dude
  stage.update()
